<div style="background: #fff; border: solid #ccc 1px; padding: 3px; border-radius: 3px;">
    <div>
        <input
            #eFilterText
            type="text"
            [(ngModel)]="filterText"
            (ngModelChange)="onInputChanged()"
            placeholder="Enter text..."
            class="form-control form-control-sm"
        />
    </div>
</div>